import React, { FC, useState } from "react";
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router';
import {
  Card,
  CardContent,
  CardHeader,
  Divider,
  Paper,
  Grid,
  Box,
  Button,
  makeStyles,
  FormControlLabel,
  Container,
  Switch,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import store from "./store"
import { observer } from "mobx-react"
import LookUp from 'components/LookUp';
import CustomTextField from "components/TextField";
import PhoneInputWithCountry from "components/PhoneField";
import MainStore from "MainStore";

type OrganizationBaseViewProps = {
  children?: React.ReactNode;
  isPopup?: boolean;
};


const BaseView: FC<OrganizationBaseViewProps> = observer((props) => {
  const { t } = useTranslation();
  const translate = t;

  const handlePhoneChange = (value: string) => {
    store.handleChange({
      target: { name: "phone", value: value }
    });
  };

  return (
    <Container maxWidth='xl' sx={{ mt: 3 }} style={{ marginTop: 20, marginBottom: 20 }}>
      <Grid container>

        <form id="OrganizationForm" autoComplete='off'>
          <Paper elevation={7}  >
            <Card>
              <CardHeader title={
                <span id="Organization_TitleName">
                  {translate('label:OrganizationAddEditView.entityTitle')}
                </span>
              } />
              <Divider />
              <CardContent>
                <Grid container spacing={3}>
                  <Grid item md={6} xs={12}>
                    <CustomTextField
                      helperText={store.errororganization_code}
                      error={store.errororganization_code != ''}
                      id='id_f_Organization_organization_code'
                      label={translate('label:OrganizationAddEditView.organization_code')}
                      value={store.organization_code}
                      onChange={(event) => store.handleChange(event)}
                      name="organization_code"
                    />
                  </Grid>
                  <Grid item md={6} xs={12}>
                    <CustomTextField
                      helperText={store.errorname}
                      error={store.errorname != ''}
                      id='id_f_Organization_name'
                      label={translate('label:OrganizationAddEditView.name')}
                      value={store.name}
                      onChange={(event) => store.handleChange(event)}
                      name="name"
                    />
                  </Grid>
                  <Grid item md={6} xs={12}>
                    <CustomTextField
                      helperText={store.errorshort_name}
                      error={store.errorshort_name != ''}
                      id='id_f_Organization_short_name'
                      label={translate('label:OrganizationAddEditView.short_name')}
                      value={store.short_name}
                      onChange={(event) => store.handleChange(event)}
                      name="short_name"
                    />
                  </Grid>
                  <Grid item md={6} xs={12}>
                    <CustomTextField
                      helperText={store.errororganization_type}
                      error={store.errororganization_type != ''}
                      id='id_f_Organization_organization_type'
                      label={translate('label:OrganizationAddEditView.organization_type')}
                      value={store.organization_type}
                      onChange={(event) => store.handleChange(event)}
                      name="organization_type"
                    />
                  </Grid>
                  <Grid item md={6} xs={12}>
                    <CustomTextField
                      helperText={store.errorinn}
                      error={store.errorinn != ''}
                      id='id_f_Organization_inn'
                      label={translate('label:OrganizationAddEditView.inn')}
                      value={store.inn}
                      // type={"number"}
                      onChange={(event) => {
                        // Разрешаем только цифры и ограничиваем длину до 14 символов
                        const numericValue = event.target.value.replace(/\D/g, '').slice(0, 14);
                        store.handleChange({
                          target: { name: "inn", value: numericValue }
                        });
                      }}
                      name="inn"
                      InputProps={{ 
                        inputProps: { maxLength: 14 }
                      }}
                    />
                  </Grid>
                  <Grid item md={6} xs={12}>
                    <CustomTextField
                      helperText={store.erroraddress}
                      error={store.erroraddress != ''}
                      id='id_f_Organization_address'
                      label={translate('label:OrganizationAddEditView.address')}
                      value={store.address}
                      onChange={(event) => store.handleChange(event)}
                      name="address"
                    />
                  </Grid>
                  <Grid item md={6} xs={12}>
                    <PhoneInputWithCountry
                      id='id_f_Organization_phone'
                      label={translate('label:OrganizationAddEditView.phone')}
                      value={store.phone}
                      onChange={handlePhoneChange}
                      error={store.errorphone != ''}
                      helperText={store.errorphone}
                    />
                  </Grid>
                  <Grid item md={6} xs={12}>
                    <CustomTextField
                      helperText={store.erroremail}
                      error={store.erroremail != ''}
                      id='id_f_Organization_email'
                      label={translate('label:OrganizationAddEditView.email')}
                      value={store.email}
                      onChange={(event) => store.handleChange(event)}
                      name="email"
                      type="email"
                    />
                  </Grid>
                  <Grid item md={4} xs={12}>
                    <CustomTextField
                      id='id_f_Organization_outgoing_doc_prefix'
                      label='Шифр нумерации исходящих документов'
                      value={store.outgoing_doc_prefix}
                      onChange={(e) => store.handleChange({ target: { name: 'outgoing_doc_prefix', value: e.target.value } })}
                      name="outgoing_doc_prefix"
                      helperText='Например: bga_eo — номер будет формироваться как bga_eo/1, bga_eo/2, ...'
                    />
                  </Grid>
                  {store.outgoing_doc_prefix && (
                    <Grid item md={2} xs={12}>
                      <CustomTextField
                        id='id_f_Organization_outgoing_doc_counter'
                        label='Текущий номер'
                        value={store.outgoing_doc_counter}
                        onChange={(e) => store.handleChange({ target: { name: 'outgoing_doc_counter', value: Number(e.target.value) } })}
                        name="outgoing_doc_counter"
                        type="number"
                        helperText={`Следующий: ${store.outgoing_doc_prefix}/${store.outgoing_doc_counter + 1}`}
                      />
                    </Grid>
                  )}
                  <Grid item md={12} xs={12}>
                    <FormControlLabel
                      control={
                        <Switch
                          checked={store.is_active}
                          onChange={(event) => store.handleChange({
                            target: { name: "is_active", value: event.target.checked }
                          })}
                          name="is_active"
                        />
                      }
                      label={translate('label:OrganizationAddEditView.is_active')}
                    />
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Paper>
        </form>
      </Grid>
      {props.children}
    </Container>
  );
})


export default BaseView;